import { Avatar } from 'components/Avatar';
import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { Txt } from 'components/Txt';
import { formatDateTimeAgo } from 'lib/riskbase';
import { theme } from 'lib/theme';
import React from 'react';
import { View } from 'react-native';

export const TaskAssignedComment: React.FC<{
  authorName: string;
  authorAvatarUrl: string | null;
  comment: string;
  createdAt: Date;
}> = ({ authorName, authorAvatarUrl, comment, createdAt }) => {
  return (
    <Card>
      <CardRow
        childrenStyle={{
          flexDirection: 'row',
          gap: theme.padding,
        }}
      >
        <Avatar
          icon={ICONS.CircleUserCustom}
          iconColor={'#bbbbbb'}
          iconPadding={0}
          data={authorAvatarUrl ? { remoteUrl: authorAvatarUrl } : null}
          size={40}
        />
        <View style={{ flex: 1 }}>
          <View style={{ flexDirection: 'row', flex: 1 }}>
            <Txt size="xxxsmall">
              <Txt weight="medium">{authorName}</Txt>
              {'  '}
              <Txt
                size="xxsmall"
                style={{ color: theme.colors.fieldValueText }}
              >
                {formatDateTimeAgo(createdAt)}
              </Txt>
            </Txt>
          </View>
          <Txt size="xsmall">{comment}</Txt>
        </View>
      </CardRow>
    </Card>
  );
};
